




















import CardComponent from './CardComponent.vue';
import GrowingNumber from './GrowingNumber.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: { GrowingNumber, CardComponent },
})
export default class CardWidget extends Vue {
  @Prop({
    default: null,
  })
  public icon!: string;

  @Prop({
    default: null,
  })
  public number!: number;

  @Prop({
    default: null,
  })
  public prefix!: string;

  @Prop({
    default: null,
  })
  public suffix!: string;

  @Prop({
    default: null,
  })
  public label!: string;

  @Prop({
    default: null,
  })
  public type!: string;
}
